/**
 * Pickup work -tilauksen työn tiedot
 */

import type { WorkDetails } from "@/types/orders";

interface OrderWorkDetailsProps {
  workDetails: WorkDetails | undefined;
}

export function OrderWorkDetails({ workDetails }: OrderWorkDetailsProps) {
  if (!workDetails) {
    return <p className="text-sm text-muted-foreground">Ei työn tietoja</p>;
  }

  const wd = workDetails;

  return (
    <div className="space-y-1 text-sm">
      {wd.name && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Nimi:</span>
          <span className="font-medium">{wd.name}</span>
        </div>
      )}
      {(wd.birth_date || wd.death_date) && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Päivämäärät:</span>
          <span>
            {wd.birth_date || "?"} – {wd.death_date || "?"}
          </span>
        </div>
      )}
      {wd.font && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Fontti:</span>
          <span>{wd.font}</span>
        </div>
      )}
      {wd.engraving_style && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Tyyli:</span>
          <span>{wd.engraving_style}</span>
        </div>
      )}
      {wd.ornament && wd.ornament !== "Ei koristetta" && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Koriste:</span>
          <span>{wd.ornament}</span>
        </div>
      )}
      {wd.additional_text && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Lisäteksti:</span>
          <span className="italic">"{wd.additional_text}"</span>
        </div>
      )}
      {wd.stone_description && (
        <div className="flex gap-2">
          <span className="text-muted-foreground">Kivi:</span>
          <span>{wd.stone_description}</span>
        </div>
      )}
      {wd.notes && (
        <div className="mt-2 text-xs text-muted-foreground">
          <span className="font-medium">Huom: </span>
          {wd.notes}
        </div>
      )}
    </div>
  );
}
